module.exports = __webpack_public_path__ + "img/facebook-inactive.84831b2.png";